<template>
  <div class="wrapper">
    <el-dialog
        :title="rowId ? '编辑角色' : '新增角色'"
        :visible.sync="showAddOrEdit"
        width="500px"
        :before-close="cancelFun"
    >
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="角色名" prop="roleName">
              <el-input v-model="formData.roleName" placeholder="角色名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="描述" prop="remark">
              <el-input
                  type="textarea"
                  rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="formData.remark"
                  placeholder="角色描述"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button type="info" size="small" @click="cancelFun">取 消</el-button>
      <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import { addRole, editRole, getRoleDetail } from './api';

export default {
  name: 'SystemRoleAddOrEdit',
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        roleName: '',
        remark: ''
      },
      rules: {
        roleName: [
          { required: true, message: '该项不能为空', trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: '角色描述不能超过200个字符', trigger: 'blur' }
        ]
      }
    }
  },

  mounted() {
    if (this.rowId) this.getRoleDetail()
  },

  methods: {
    submitFun() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // 编辑
          await (this.rowId ? editRole : addRole)(this.formData).then(() => {
            this.$message.success(this.rowId ? '编辑成功' : '新增成功');
            this.$emit("closeDialog",true);
          })
        } else {
          return false;
        }
      })
    },
    async getRoleDetail() {
      this.formData = await getRoleDetail({ id: this.rowId });
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  .el-form /deep/ {
    .el-form-item {
      .el-form-item__content {
        width: 70%;
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>
